import axios from 'axios';
import router from '../router';
import {store} from '../store/index';
import LoginService from '../../../services/login.service';

export default class Api {
  constructor(skipUserId, defaultParams) {
    this.skipUserId = skipUserId;
    this.defaultParams = defaultParams;
  }

  get() {
    return new Promise((resolve, reject) => {
      LoginService.getActiveSession().then((user) => {
        const api = getApi('Bearer ' + user.apiToken.access_token, this.skipUserId, this.defaultParams);
        resolve(api.get(...arguments));
      }, (error) => reject(error));
    });
  }

  put() {
    return new Promise((resolve, reject) => {
      LoginService.getActiveSession().then((user) => {
        const api = getApi('Bearer ' + user.apiToken.access_token, this.skipUserId, this.defaultParams);
        resolve(api.put(...arguments));
      }, (error) => reject(error));
    });
  }

  patch() {
    return new Promise((resolve, reject) => {
      LoginService.getActiveSession().then((user) => {
        const api = getApi('Bearer ' + user.apiToken.access_token, this.skipUserId, this.defaultParams);
        resolve(api.patch(...arguments));
      }, (error) => reject(error));
    });
  }

  post() {
    return new Promise((resolve, reject) => {
      LoginService.getActiveSession().then((user) => {
        const api = getApi('Bearer ' + user.apiToken.access_token, this.skipUserId, this.defaultParams);
        resolve(api.post(...arguments));
      }, (error) => reject(error));
    });
  }

  delete() {
    return new Promise((resolve, reject) => {
      LoginService.getActiveSession().then((user) => {
        const api = getApi('Bearer ' + user.apiToken.access_token, this.skipUserId, this.defaultParams);
        resolve(api.delete(...arguments));
      }, (error) => reject(error));
    });
  }
}

function getApi(token, skipUserId, defaultParams) {
  const apiUrl = window.Config.apiGateway;
  const adminUrl = window.Config.adminUrl || window.Config.apiGateway;
  let axiosConfig = {
    baseURL: apiUrl,
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': token
    }
  };
  const api = axios.create(axiosConfig)

  api.defaults.params = defaultParams || {};

  if (!skipUserId) {
    api.defaults.params.userId = store.getters['user/getUserId'];
  }

  api.interceptors.request.use(async req => {
    if (req.url.indexOf('admin/') > -1) {
      req.baseURL = adminUrl;
    } else {
      req.baseURL = apiUrl;
    }
    return req;
  });

  api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response && (error.response.status === 401) && !error.config.url.includes('getConfigFile')) {
      store.dispatch('user/logout');
      router.replace({ path: "/" });
    }
    return Promise.reject(error);
  })

  return api;
}
